import { useEffect } from 'react';
import { useTableContext } from './table-context';
import useWarning from '../utils/use-warning';

var TableColumn = function TableColumn(_ref) {
  var children = _ref.children,
      prop = _ref.prop,
      label = _ref.label,
      width = _ref.width;

  var _useTableContext = useTableContext(),
      appendColumn = _useTableContext.appendColumn;

  if (!prop || prop.trim() === '') {
    useWarning('The props "prop" is required.', 'Table.Column');
  }

  useEffect(function () {
    appendColumn && appendColumn({
      label: children || label,
      value: "".concat(prop).trim(),
      width: width
    });
  }, []);
  return null;
};

export default TableColumn;